// Simple data file without JSX
export const IMAGES = {
  hero: 'https://images.unsplash.com/photo-1581093450725-0a13a6d122d6?q=85',
  about: 'https://images.unsplash.com/photo-1531956656798-56686eeef3d4?q=85',
  rd: 'https://images.unsplash.com/photo-1707944746058-4da338d0f827?q=85',
  evBattery: 'https://images.unsplash.com/photo-1640596077803-f819d8d0c772?q=85',
  industrial: 'https://images.unsplash.com/photo-1751486289950-5c4898a4c773?q=85',
  transportation: 'https://images.unsplash.com/photo-1647427060118-4911c9821b82?q=85',
  aerospace: 'https://images.unsplash.com/photo-1692128237627-e756e994b048?q=85',
  logo: 'https://customer-assets.emergentagent.com/job_5e64245c-1d1f-4436-8cfb-bf9096ddb29a/artifacts/or26avje_WhatsApp%20Image%202026-01-31%20at%2021.10.19.jpeg',
  founderPhoto: 'https://customer-assets.emergentagent.com/job_5e64245c-1d1f-4436-8cfb-bf9096ddb29a/artifacts/62qjap3f_WhatsApp%20Image%202026-01-31%20at%2022.34.27.jpeg'
};

export const CONTACT = {
  founderName: 'Nitin Singh',
  founderEmail: 'Nitin@solidcloudintl.com',
  generalEmail: 'Info@solidcloudintl.com'
};
